import { Col, Modal, Row, Button, Image } from 'antd';
// import { useState } from 'react';

import { useSelector } from 'react-redux';
import { useState } from 'react';
import { RoundedIcon } from '../Rounded-icon/RoundedIcon';
import Icons from '../../../configs/icon.config';
import doorIcon from '../../../assets/welcome-img.png';
import {
  Guidedtour,
  useUpdateApplicationSettingMutation,
} from '../Tour/store/GuidedTourSlice';
import { useGetUserProfileQuery } from '../../../app/auth/apiSlice';
import { authState } from '../../../app/auth/authSlice';

function WelcmeModal() {
  const { token } = useSelector(authState);
  const { data: userProfile } = useGetUserProfileQuery(undefined, {
    skip: !token,
  });
  const [userSetting, setUserSetting] = useState<any>();
  const [updateWelcomeModal, { isLoading }] =
    useUpdateApplicationSettingMutation();
  const updatedWelcomeModalSettings: Guidedtour = {
    welcome_modal: 'false',
  };
  const updatedTourSettings: Guidedtour = {
    welcome_modal: 'false',
    guided_tour: 'true',
  };
  // const navigate = useNavigate();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const showModal = () => {
  //   setIsModalOpen(true);
  // };

  // const handleOk = () => {
  //   setIsModalOpen(false);
  // };

  // const handleCancel = () => {
  //   setIsModalOpen(false);
  // };

  const handleEnter = async () => {
    // setIsModalOpen(false);
    try {
      const res = await updateWelcomeModal(
        updatedWelcomeModalSettings
      ).unwrap();
      setUserSetting(res);
    } catch (err) {
      console.error('Error updating welcome modal settings:', err);
    }
  };
  const handleTour = async () => {
    // setIsModalOpen(false);
    try {
      const res = await updateWelcomeModal(updatedTourSettings).unwrap();
      setUserSetting(res);
    } catch (err) {
      console.error('Error updating guided tour settings:', err);
    }
  };

  return (
    <Modal
      className="overflow-y-scroll md:overflow-hidden h-[350px] md:h-auto"
      // title="Welcome"
      // bodyStyle={{
      //   overflowY: 'scroll',
      //   height: 'calc(100vh - 230px)',
      // }}
      open={
        userSetting
          ? userSetting?.welcome_modal
          : userProfile?.user_settings?.welcome_modal
      }
      closable={false}
      width={900}
      centered
      // onOk={handleOk}
      // onCancel={handleCancel}
      footer={[
        <Row key={1} className="border-t-2 border-t-gray-100">
          {/* <Col span={12} /> */}
          <Col
            span={24}
            className="flex flex-row md:justify-end justify-center md:gap-10 gap-3 mt-6"
          >
            <Button
              className="h-[41px] flex items-center py-2 cursor-pointer hover:scale-[1.03] transition-all hover:shadow-sm hover:shadow-pink-600 border-pink-600"
              style={{ borderRadius: 0 }}
              onClick={handleEnter}
              disabled={isLoading}
            >
              <div className="flex gap-2 justify-center items-center px-2 md:px-10">
                <Col className="text-[20px] text-pink-600 mb-2">
                  {Icons.back}
                </Col>
                <Col className="text-2xl font-bold text-pink-600">
                  Enter MyBRAC
                </Col>
              </div>
            </Button>
            <div className="hidden md:block">
              <Button
                className=" bg-[#D10D74] h-[41px] flex items-center py-2 cursor-pointer hover:scale-[1.03] transition-all hover:shadow-sm hover:shadow-pink-600 "
                style={{ borderRadius: 0 }}
                onClick={handleTour}
                disabled={isLoading}
              >
                <div className="flex gap-2 justify-center items-center p-5 lg:px-5 md:px-10">
                  <Col className="text-[20px] text-white mb-2">
                    {Icons.back}
                  </Col>
                  <Col className="text-2xl font-extrabold text-white">
                    Take Tour
                  </Col>
                </div>
              </Button>
            </div>
          </Col>
        </Row>,
      ]}
    >
      <Row className="flex flex-row justify-between border-b-2 border-b-gray-100 pb-2 ">
        <h1 className="text-[#000000] text-bold text-[23px]">Welcome</h1>
        <RoundedIcon
          onClick={handleEnter}
          iconName={Icons.cross}
          classname="search-button  cursor-pointer hover:scale-110 mt-1"
          width={25}
          height={25}
          styles={{ fontSize: 25 }}
        />
      </Row>
      <Row className="p-8 flex-col md:flex-row items-center">
        <Col md={12} sm={24}>
          <p className="text-[30px] md:text-[50px] text-black font-bold leading-normal">
            Welcome to the new MyBRAC!
          </p>
          <div className="text-[18px] text-[#212121] mt-8">
            The one place to perform all your BRAC related activities and more!
          </div>
          <div className="text-[18px] text-[#212121] mt-8">
            All the features of the old familiar MyBRAC (and many new ones) can
            be found here but with many improvements and a new look.
          </div>
          <div className="text-[18px] text-[#212121] mt-8">
            We hope you enjoy your time here. Cheers!
          </div>
        </Col>
        <Col md={12} sm={24} className="p-8">
          <Image src={doorIcon} preview={false} />
        </Col>
      </Row>
    </Modal>
  );
}

export default WelcmeModal;
